import { useState } from "react";
import ArrayField from "./ArrayField";
import TextField from "./TextField";

export default function VacancyEditMode({ vacancy, onCancel, onUpdate }) {
  const [updatedVacancy, setUpdatedVacancy] = useState(vacancy);

  const onChangeField = (field, value) => {
    setUpdatedVacancy((prev) => ({ ...prev, [field]: value }));
  };

  const onChangeArrayField = (field, index, value) => {
    setUpdatedVacancy((prev) => {
      const arr = Array.isArray(prev[field]) ? [...prev[field]] : [];
      arr[index] = value;
      return { ...prev, [field]: arr };
    });
  };

  const onAddArrayField = (field) => {
    setUpdatedVacancy((prev) => {
      const arr = Array.isArray(prev[field]) ? [...prev[field]] : [];
      arr.push("");
      return { ...prev, [field]: arr };
    });
  };

  const onRemoveArrayField = (field, index) => {
    setUpdatedVacancy((prev) => {
      const arr = Array.isArray(prev[field]) ? [...prev[field]] : [];
      arr.splice(index, 1);
      return { ...prev, [field]: arr };
    });
  };

  return (
    <div className="bg-white rounded-xl shadow p-6 mb-6 border border-gray-100">
      <div className="flex items-center justify-between mb-4">
        <h4 className="text-lg font-bold text-gray-900">职位描述智能解析</h4>
        <div className="flex gap-2">
          <button
            onClick={() => onUpdate(updatedVacancy)}
            className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 font-semibold mr-2"
          >
            保存
          </button>
          <button
            onClick={onCancel}
            className="inline-flex items-center px-4 py-2 bg-gray-200 text-gray-700 rounded-lg shadow hover:bg-gray-300 focus:outline-none font-semibold"
          >
            取消
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* 职位名称 */}
        <TextField
          name="title"
          value={updatedVacancy.title}
          label="职位名称"
          onChange={onChangeField}
        />
        {/* 必备技能 */}
        <ArrayField
          name="required_skills"
          values={updatedVacancy.required_skills}
          label="必备技能"
          onAdd={onAddArrayField}
          onChange={onChangeArrayField}
          onRemove={onRemoveArrayField}
        />
        {/* 优先技能 */}
        <ArrayField
          name="preferred_skills"
          values={updatedVacancy.preferred_skills}
          label="优先技能"
          onAdd={onAddArrayField}
          onChange={onChangeArrayField}
          onRemove={onRemoveArrayField}
        />
        {/* 主要职责 */}
        <ArrayField
          name="responsibilities"
          values={updatedVacancy.responsibilities}
          label="主要职责"
          onAdd={onAddArrayField}
          onChange={onChangeArrayField}
          onRemove={onRemoveArrayField}
        />
        {/* 加分项 */}
        <ArrayField
          name="bonus_skills"
          values={updatedVacancy.bonus_skills}
          label="加分项"
          onAdd={onAddArrayField}
          onChange={onChangeArrayField}
          onRemove={onRemoveArrayField}
        />
        {/* 隐含要求 */}
        <ArrayField
          name="hidden_requirements"
          values={updatedVacancy.hidden_requirements}
          label="隐含要求"
          onAdd={onAddArrayField}
          onChange={onChangeArrayField}
          onRemove={onRemoveArrayField}
        />
        {/* 工作经验要求 */}
        <TextField
          name="years_experience"
          value={updatedVacancy.years_experience}
          label="工作经验要求"
          onChange={onChangeField}
        />
        {/* 学历要求 */}
        <TextField
          name="education_level"
          value={updatedVacancy.education_level}
          label="学历要求"
          onChange={onChangeField}
        />
      </div>
    </div>
  );
}
